export default __webpack_public_path__ + "static/media/man.2e8c0c9d.jpg";